import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { ProposalComment, AttachFile } from "src/redux/projects";
import { createModal } from "react-modal-promise";

import { toast } from "react-toastify";
import { setUploadFiles } from "src/api/projects";
import { config } from "src/config/config";
interface Props {
  comment: ProposalComment;
  showWarning: boolean;
  // open and close are given via react-modal-promise HOC
  open: boolean;
  close: (data: {
    text: string | null;
    remove: boolean;
    files?: AttachFile[];
  }) => void;
}

interface State {
  text: string;
  files: AttachFile[];
}

type PropsWithNamespaces = Props & WithNamespaces;

class CommentModal extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    text: this.props.comment.text,
    files: this.props.comment.files ? this.props.comment.files : []
  };

  onCommentChange = e => {
    this.setState({ text: e.target.value });
  };
  removePin = () =>
    this.props.close({
      text: null,
      remove: true
    });

  /**
   * Dismiss a modal: return null as modal result
   */
  dismiss = () => this.props.close({ remove: false, text: null });

  /**
   * Transmit modal result while closing it
   */
  transmit = () =>
    this.props.close({
      remove: false,
      text: this.state.text,
      files: this.state.files
    });
  handleChange = async ev => {
    try {
      if (ev.target.files[0].size > config.maxFileSizeUpload) {
        toast.error(this.props.t("proposal.files.maximumSizeExceeded"));
        return;
      }
      const file = await setUploadFiles(ev.target.files[0]);

      this.setState({
        files: [...this.state.files, file]
      });
    } catch (e) {
      if (e.response.data.message === "UNVALID_EXTENSION") {
        toast.error(this.props.t("proposal.files.unvalidExtension"));
        return;
      }
      toast.error("Upload files error");
    }
  };
  deleteFile = file => {
    this.setState({
      files: [...this.state.files.filter(f => f.id !== file.id)]
    });
  };
  render() {
    /* This modal should be in a promise, so it's always open */
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.dismiss}
        className="comment-modal"
      >
        <ModalHeader toggle={this.dismiss}>
          <span className="flex-1">{this.props.t("commentModal.title")}</span>
          <img
            onClick={this.removePin}
            src="assets/svgs/baseline-delete.svg"
            alt="delete"
          />
        </ModalHeader>
        <ModalBody>
          {this.props.showWarning && (
            <div className="alert alert-danger fade show text-center mb-2">
              Note : vous pouvez effectuer jusqu'à {config.maxCommentCount} annotations. Les annotations supplémentaires feront l'objet d'une facturation complémentaire.
            </div>
          )}

          <textarea
            className="comment-modal-textarea"
            placeholder="..."
            value={this.state.text}
            onChange={this.onCommentChange}
          />
          <label className="cursor-pointer">
            <img className="mr-2" width="20px" src="assets/svgs/clip.svg" />
            <input
              type="file"
              className="d-none"
              onChange={this.handleChange}
            />
            {this.props.t("proposal.artwork.validation.fileUrl")}
            <small className="ml-1">
              {this.props.t("proposal.files.maximumSize")}
            </small>
          </label>
          {this.state.files.length > 0 && (
            <div>
              <p className=" mt-2 mb-2">
                {this.props.t("proposal.files.title")}
              </p>
              <div>
                {this.state.files.map(file => (
                  <div className="d-flex" key={file.id}>
                    <a className="flex-1" target="_blank" href={file.url}>
                      <img
                        width="16px"
                        src="assets/svgs/outline-cloud_download.svg"
                      />
                      <small className="ml-2">{file.filename}</small>
                    </a>

                    <img
                      onClick={e => this.deleteFile(file)}
                      src="/assets/svgs/baseline-close.svg"
                      width="16px"
                      className="cursor-pointer"
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.dismiss}>
            {this.props.t("commentModal.cancel")}
          </Button>{" "}
          <Button
            disabled={!this.state.text}
            color="primary"
            onClick={this.transmit}
          >
            {this.props.t("commentModal.validate")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createModal(withNamespaces()(CommentModal));



// WEBPACK FOOTER //
// ./src/components/CommentModal.tsx